import { useSelector } from 'react-redux'


export default function useFctMeta (contactId) {
  return useSelector(state => state.status.student_meta.fct_contracts.find(fct => fct.contract_id === parseInt(contactId)))
}
